<template>
  <div>
    <div class="home-map" id="basicMap" />
    <div class="link-set text-center">
      <span class="link-set-link"><a href="#" @click="setCenter('US')">United States</a></span>
      <span class="link-set-link"><a href="#" @click="setCenter('AR')">Argentina</a></span>
      <span class="link-set-link"><a href="#" @click="setCenter('CA')">Canada</a></span>
      <span class="link-set-link"><a href="#" @click="setCenter('CN')">China</a></span>
      <span class="link-set-link"><a href="#" @click="setCenter('AE')">United Arab Emirates</a></span>
    </div>
  </div>
</template>

<script>
import gmapsInit from './googlemaps.js';
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'
import Constants from '../Common/Constants.js'

export default {
  name: 'MapWidget',
  mixins: [
    CrudOperationsMixin
  ],
  props: [
    'subscriptionWrappers'
  ],
  data() {
    return {
      google: null,
      map: null,
      stations: null,
      openInfoWindow: null,
      buttonSubmitType: null,
      triggers: Constants.triggers
    };
  },
  computed: {
  },
  methods: {
    setCenter: function (location)  {
      // U.S.
      let center = { lat: 39.8283, lng: -98.5795 };
      let zoom = 4;

      if (location == 'AR') {
        center = { lat: -37.12, lng: -62.59 };
        zoom = 4;
      } else if (location == 'CA') {
        center = { lat: 52.86, lng: -94.29 };
        zoom = 4;
      } else if (location == 'CN') {
        center = { lat: 36.04, lng: 102.55 };
        zoom = 4;
      } else if (location == 'AE') {
        center = { lat: 24.06, lng: 54.72 };
        zoom = 6;
      }

      this.map.setCenter(center);
      this.map.setZoom(zoom);
    },
    load: function () {
      this.readQuery('/graphql/public', {
        query: `
          query {
            stations (limit: 1000, filter: "isOnMap = true") {
              id,
              displayCity,
              name,
              city,
              state,
              postalCode,
              country,
              latitude,
              longitude
            }
          }`
        }, (data) => {
          this.stations = data.stations;

          this.stations.forEach(s => {
            let marker = new google.maps.Marker({
              position: {
                lat: s.latitude,
                lng: s.longitude
              },
              map: this.map
            });

            marker.addListener('click', e => {
              if (this.openInfoWindow)
                this.openInfoWindow.close();

              this.buttonSubmitType = null;

              let existingSubscriptionWrapper = this.subscriptionWrappers.find(x => x.subscriptionOrRole.station.id == s.id && x.type == 'subscription');

              let options = this.triggers.filter(x => x.value).map(x => { return '<option value="' + x.value + '">' + x.text + '</option>' });

              let content = document.createElement('div');
              content.innerHTML = '<div>' +
                '<div style="font-size: 175%;font-weight:bold;"><a href="#/station/' + s.id + '">' + s.displayCity + ', ' + s.state + '</a></div>' +
                '<div style="font-size: 100%"><a href="#/station/' + s.id + '">' + s.name + '</a></div>' +
                '<hr style="margin: 8px 0 8px 0;" />' +
                '<div style="font-size: 110%; padding-bottom: 8px;">Sign up for email alerts when levels change at this station.</div>' +
                '<form style="font-size: 75%;">' +
                  '<fieldset class="form-group">' +
                    '<select class="custom-select">' + options + '</select>' +
                  '</fieldset>' +
                  '<div class="btn-group">' +
                    (existingSubscriptionWrapper ? '' + 
                      '<button type="submit" class="btn btn-secondary update-subscription">Change Email Alerts</button>' + 
                      '<button type="submit" class="btn btn-secondary remove-station">Remove from My NAB</button>' :
                      '<button type="submit" class="btn btn-secondary add-station">Add Station to My NAB</button>'
                    ) +
                  '</div>' +
                '</form>' +
              '</div>';

              if (existingSubscriptionWrapper) {
                content.querySelector('select').value = existingSubscriptionWrapper.subscription.trigger;
                content.querySelector('.update-subscription').onclick = (e) => {
                  this.buttonSubmitType = 'update-subscription';
                }
                content.querySelector('.remove-station').onclick = (e) => {
                  this.buttonSubmitType = 'remove-station';
                }
              }

              content.querySelector('form').onsubmit = (e) => {
                if (this.openInfoWindow) {
                  this.openInfoWindow.close();
                  this.openInfoWindow = null;
                }

                let trigger = content.querySelector('select').value;

                if (existingSubscriptionWrapper) {
                  if (this.buttonSubmitType == 'update-subscription') {
                    this.$emit('subscriptionUpdated', existingSubscriptionWrapper.subscription.id, trigger);
                  } else if (this.buttonSubmitType == 'remove-station') {
                    this.$emit('stationRemoved', existingSubscriptionWrapper.subscription.id);
                  }
                }
                else
                  this.$emit('stationAdded', s.id, trigger);

                return false;
              };

              this.openInfoWindow = new google.maps.InfoWindow({
                content: content
              });

              this.openInfoWindow.open(this.map, marker);
            });
          });
        });
    },
  },
  async mounted () {
    this.google = await gmapsInit();
    this.map = new google.maps.Map(document.getElementById('basicMap'), {
      center: { lat: 39.8283, lng: -98.5795 },
      zoom: 4,
      //gestureHandling: 'greedy'
    });

    // this.map.addListener('center_changed', () => {
    //   let lat = this.map.getCenter().lat();
    //   let lng = this.map.getCenter().lng();
    //   console.log(lat + ', ' + lng);
    // });

    // this.map.addListener('zoom_changed', () => {
    //   console.log(this.map.getZoom());
    // });

    this.load();
  }
}
</script>